function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import ParagraphAndAssetColumnsComponent from "/components/core/paragraph-and-asset-columns/paragraph-and-asset-columns-component";
import StarsComponent from "components/core/stars/stars-component";
import { StyledCustomerSuccessComponent } from "./customer-success-component.scss";
class CustomerSuccessComponent extends PureComponent {
    render() {
        const { columnWidth, imageWidth } = this.props;
        return /*#__PURE__*/ _jsx(StyledCustomerSuccessComponent, {
            className: `customer-success-component`,
            children: this.props.assets.map((assetAndParagaph, index)=>{
                const { stars } = assetAndParagaph;
                const { showStars } = stars || {};
                return /*#__PURE__*/ _jsxs("div", {
                    className: "customer-success-item-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx(ParagraphAndAssetColumnsComponent, _object_spread_props(_object_spread({}, assetAndParagaph), {
                            columnWidth: columnWidth,
                            imageWidth: imageWidth
                        })),
                        showStars && /*#__PURE__*/ _jsx(StarsComponent, _object_spread({}, stars))
                    ]
                }, index);
            })
        });
    }
}
export { CustomerSuccessComponent as default };
CustomerSuccessComponent.defaultProps = {
    columnWidth: "240px",
    imageWidth: "200px",
    assets: [
        {
            asset: {
                shadow: false,
                image: {
                    src: "/static/img/customer-success/tan.png",
                    alt: "Webinars"
                }
            },
            content: {
                title: "Webinars",
                textDirection: "center",
                body: [
                    "On-demand or live, get in-depth knowledge on a variety of topics"
                ],
                bottomLink: {
                    text: "Attend a webinar",
                    href: "/webinars"
                }
            }
        },
        {
            asset: {
                shadow: false,
                image: {
                    src: "/static/img/customer-success/shira.png",
                    alt: "Articles"
                }
            },
            content: {
                title: "Articles",
                textDirection: "center",
                body: [
                    "If words are more your thing, read up on all things why, how and what"
                ],
                bottomLink: {
                    text: "Read an article",
                    href: "/support"
                }
            }
        },
        {
            asset: {
                shadow: false,
                image: {
                    src: "/static/img/customer-success/omri.png",
                    alt: "Tutorials"
                }
            },
            content: {
                title: "Tutorials",
                textDirection: "center",
                body: [
                    "Funny and functional, our tutorials will take you through every process step-by-step"
                ],
                bottomLink: {
                    text: "Watch a tutorial",
                    href: "/guides"
                }
            }
        }
    ]
};
